import { Alert, Button, Form, Input, Typography } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthError } from '~/constants/error';
import { saveLoginData } from '../../utils/auth';
import { login } from './api';
import './style.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await login(values);
      saveLoginData(data);
      navigate('/');
    } catch (e: any) {
      switch (e.error) {
        case AuthError.InvalidLogin:
          setError('Username atau PIN salah');
          break;
        default:
          setError(e.errorMsg);
      }
      return;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <Typography.Title>Login</Typography.Title>
      {error ? (
        <Alert type="error" message={error} style={{ width: '100%' }} />
      ) : null}
      <Form
        name="login"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        style={{ width: '100%' }}
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Username harus diisi!' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="PIN"
          name="pin"
          rules={[{ required: true, message: 'PIN harus diisi!' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item style={{ marginTop: 32 }}>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
